const CARDS = [
  {
    title: '《葬送的芙莉莲》',
    desc: '勇者死后数十年的魔法使之旅，治愈与感动的完美结合，年度口碑神作。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20scene%20with%20a%20gentle%20elf%20mage%20walking%20through%20a%20peaceful%20meadow%20at%20sunset%2C%20warm%20golden%20hour%20lighting%2C%20nostalgic%20atmosphere%2C%20soft%20breeze%20moving%20grass%2C%20minimalist%20composition%2C%20beautiful%20anime%20art%20style&width=600&height=400&seq=card-01&orientation=landscape',
    tag: '治愈',
    score: '9.8',
  },
  {
    title: '《鬼灭之刃 柱训练篇》',
    desc: '万众期待的柱训练篇震撼开播，炎柱与恋柱的精彩故事不容错过。',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20anime%20action%20scene%20with%20sword-wielding%20characters%20in%20traditional%20Japanese%20setting%2C%20dramatic%20fire%20and%20water%20effects%2C%20warm%20orange%20and%20crimson%20tones%2C%20epic%20composition%2C%20high%20quality%20anime%20illustration&width=600&height=400&seq=card-02&orientation=landscape',
    tag: '战斗',
    score: '9.6',
  },
  {
    title: '《我推的孩子 第二季》',
    desc: '娱乐业界背后的真相与梦想交织，深入演艺圈的震撼续篇。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20scene%20with%20idol%20characters%20on%20bright%20stage%20under%20spotlights%2C%20glamorous%20performance%20atmosphere%2C%20sparkling%20stage%20effects%2C%20vibrant%20pink%20and%20purple%20lighting%2C%20emotional%20moment%2C%20modern%20anime%20style&width=600&height=400&seq=card-03&orientation=landscape',
    tag: '偶像',
    score: '9.5',
  },
  {
    title: '《咒术回战 死灭回游》',
    desc: '史上最残酷的死灭回游篇章开幕，咒术师与咒灵的终极对决！',
    image: 'https://readdy.ai/api/search-image?query=Intense%20anime%20supernatural%20battle%20scene%20with%20dark%20energy%20and%20cursed%20spirits%2C%20urban%20Tokyo%20backdrop%2C%20dramatic%20contrast%20lighting%2C%20dark%20purple%20and%20crimson%20tones%2C%20cinematic%20composition%2C%20high%20detail%20anime%20art&width=600&height=400&seq=card-04&orientation=landscape',
    tag: '奇幻',
    score: '9.7',
  },
  {
    title: '《间谍过家家 第二季》',
    desc: '伪装家族的搞笑日常继续上演，阿尼亚的校园生活欢乐加倍！',
    image: 'https://readdy.ai/api/search-image?query=Wholesome%20anime%20family%20scene%20in%20cozy%20European-style%20living%20room%2C%20warm%20afternoon%20sunlight%2C%20cheerful%20expressions%2C%20soft%20cream%20and%20pastel%20pink%20tones%2C%20slice%20of%20life%20atmosphere%2C%20modern%20anime%20art&width=600&height=400&seq=card-05&orientation=landscape',
    tag: '搞笑',
    score: '9.4',
  },
  {
    title: '《Re:从零开始的异世界生活》',
    desc: '死亡回归的绝望与希望，菜月昴在异世界的残酷旅程仍未结束。',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20anime%20scene%20in%20mysterious%20otherworld%20with%20ancient%20castle%20ruins%2C%20ethereal%20blue%20and%20silver%20lighting%2C%20magical%20particles%20floating%2C%20dramatic%20atmosphere%2C%20beautiful%20anime%20illustration%20style&width=600&height=400&seq=card-06&orientation=landscape',
    tag: '奇幻',
    score: '9.6',
  },
  {
    title: '《怪兽8号》',
    desc: '普通打工人变身最强怪兽防卫队成员，热血科幻战斗新篇章。',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20anime%20scene%20with%20giant%20kaiju%20monster%20in%20destroyed%20cityscape%2C%20military%20defense%20team%20in%20action%2C%20explosive%20orange%20and%20grey%20tones%2C%20dramatic%20scale%2C%20high%20quality%20anime%20style&width=600&height=400&seq=card-07&orientation=landscape',
    tag: '科幻',
    score: '9.3',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">精选推荐</h2>
          <p className="text-sm text-foreground-500">编辑精选高分动漫，口碑与热度双在线</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {CARDS.map((card) => (
            <article
              key={card.title}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer hover:border-accent-200 transition-all duration-300"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-background-100">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  <span className="px-2 py-0.5 text-[11px] font-medium rounded-full bg-primary-500 text-background-50">
                    {card.tag}
                  </span>
                  <span className="px-2 py-0.5 text-[11px] font-medium rounded-full bg-foreground-950/70 text-background-50">
                    {card.score}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-heading text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}